export default "__VITE_ASSET__BJe$ryma__"